export const entityTypes = {
  ItemTypes: 109,
  ItemTypeSubItem: 111,
  ActualItems: 139,
  SubitemVariant: 161,
  ItemGroups: 113,
  Customers: 6,
  CustomerGroups: 62,
  CustomerCategory: 42,
}
